import { BillingSidebarComponent } from '../billing-sidebar/billing-sidebar.component';
import { ImportantMessageSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/important-message-svg/important-message-svg.component';
import { MapfreAlertComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Params , RouterModule } from '@angular/router';
import { PolicyDataService } from './../../../../../_services/data-services/policy-data.service';
import { Component, OnInit } from '@angular/core';
import { BillingDataService } from '../../../../../_services/data-services/billing-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreAlertComponent, ImportantMessageSvgComponent, BillingSidebarComponent],
  selector: 'app-payment-error',
  templateUrl: './payment-error.component.html',
  styleUrls: ['./payment-error.component.scss'],
})
export class PaymentErrorComponent implements OnInit {
  billing: any;
  policyDetails: any;
  policyId: any;
  errorCode: any;

  constructor(
    private billingDataService: BillingDataService,
    private policyDataService: PolicyDataService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
      this.errorCode = params['errorCode'];
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        this.policyDetails = policyResponse;
      });
      this.billingDataService.$billingDetailsEcheck.subscribe((billing) => {
        this.billing = billing;
      });
    });
  }
}
